<style scoped>
  .header{
    background: '#fff';
    boxShadow: '0 2px 3px 2px rgba(0,0,0,.1)';

  }
    .ivu-layout-content{
      margin-top: 14px;
    }
    .layout{
        border: 1px solid #d7dde4;
        background: #f5f7f9;
        position: relative;
        border-radius: 4px;
        overflow: hidden;
    }
    .layout-header-bar{
        background: #fff;
        box-shadow: 0 1px 1px rgba(0,0,0,.1);
    }
    .headBox{
      display: flex;
      justify-content: space-between;
      color: white;
      padding: 0 20px;
    }
    .layout-nav{
        width: 420px;
        margin-right: 20px;
        color: white;
        text-align: right;
    }
.logoBox{

}
.logo{
  width: 100px;
  height: 100px;
  display: block;
  margin: 20px auto;
}
</style>
<template>
    <div class="layout">
        <Sider :style="{position: 'fixed', height: '100vh', left: 0, overflow: 'auto'}">
          <div class="logoBox">
            <img src="../assets/logo.png" class="logo">


          </div>
    <!--         <Menu theme="dark"
                    width="auto"

                    :active-name="$route.path"
              >

                  <Submenu v-for="(item,index) in menuList" :key="index" :name="index" >
                      <template slot="title">
                        <span  @click='capital'>
                            <Icon :type="item.icon" />
                            {{item.title}}
                        </span>
                      </template>
                      <MenuItem v-for="(child,index) in item.children"
                                ref="menuOpen"
                                :name="child.name"
                                :key="child.data.menuUrl"
                                :to="child.data.menuUrl">
                                 <Icon :type="child.icon" />
                          {{child.title}}
                      </MenuItem>
                  </Submenu>
              </Menu> -->
           <Menu active-name="1-1" theme="dark" width="auto" :open-names="['1']">
                <Submenu name="1">
                    <template slot="title">
                        <Icon type="ios-navigate"></Icon>
                         图片管理
                    </template>
                    <MenuItem name="1-1" :name="pic" to="pic">图片列表</MenuItem>

                </Submenu>
                <Submenu name="2">
                    <template slot="title">
                        <Icon type="ios-keypad"></Icon>
                       开奖管理
                    </template>
                    <MenuItem name="2-1" :name="open" to="open">开奖数据</MenuItem>
					 <!-- <MenuItem name="2-2" :name="open" to="list">开奖记录</MenuItem> -->

                </Submenu>

            </Menu>
        </Sider>
        <Layout :style="{marginLeft: '200px'}">
            <Header class='header'>
                <Menu mode="horizontal" theme="dark" active-name="1">
                      <div class="headBox">
                          <div class="layout-logo">
                          <Select v-model="model1" style="width:200px" @on-change='change'>
                                  <Option v-for="item in list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                              </Select>
                          </div>
                           <div class="layout-nav">
                             <div>
								    {{loginName}}
                                <!-- <Icon type="md-contact"></Icon>
                                名字 -->
                                 <!-- <Dropdown>
                                   <a href="javascript:void(0)">
                                     <Icon type="md-contact"></Icon>
                                     {{loginName}}
                                     <Icon type="ios-arrow-down"></Icon>
                                   </a>
                                   <DropdownMenu slot="list" >
                                     <DropdownItem name="loginOut"  @on-click="quit">退出</DropdownItem>
                                   </DropdownMenu>
                                 </Dropdown> -->
                             </div>
                           </div>

                      </div>

                </Menu>
            </Header>
            <Content :style="{padding: '0 16px 16px'}">
             <!--   <Breadcrumb :style="{margin: '16px 0'}">
                    <BreadcrumbItem>Home</BreadcrumbItem>
                    <BreadcrumbItem>Components</BreadcrumbItem>
                    <BreadcrumbItem>Layout</BreadcrumbItem>
                </Breadcrumb> -->
                <Card>
                   <router-view  v-if="isRouterAlive"/>
                </Card>
            </Content>
        </Layout>
    </div>
</template>
<script>
    export default {
     inject:['reload'],
      created(){  //生命周期里接收参数
      // console.log(this.$md5('holle world') )
       this.model1 =   sessionStorage.setItem('type')
        	},
      mounted() {
  // console.log('jinru ')
  // console.log(this.$md5('holle world') )
  // var baseUrl = this.baseUrl;
  // console.log(baseUrl)
  // console.log( sessionStorage.getItem('token'))
// let testObj = {
//     name: 'yaobo',
//     age: 'what',
//     sex: 'man',
//     address: '湖南'
// }







//   var json={
//   	"name":"乔峰",
//   	"age":"10",
//   	"sex":"男"
//   };
//   var str = ''

//   for(var key in json){
//   	console.log(key+":"+json[key]);
//     str+= key+json[key]

// }
// console.log(str)
// this.$get('api/admin/MenuSetting/GetTreeList',{ StaffID:0,appkey:0})
//       .then((response) => {
//         console.log(response)
//       })


   // this.getMennu()
             //             this.$router.push({  //核心语句
      	      //    path:'/data', //跳转的路径
      	      //    name:'data',
      	      // })

             },
  data(){
  	 return {
            isRouterAlive :true,
            loginName:'管理员',
            isCollapse: false,
            openIndex:'1',
            menuList:[],
            list:[{
                           value: '1',
                           label: '泰国'
                       },
                       {
                           value: '2',
                           label: '新加坡'
                       },
                       {
                           value: '3',
                           label: '韩国福利'
                       },
                       {
                           value: '4',
                           label: '越南万合'
                       },
                       {
                           value: '5',
                           label: '澳门金沙'
                       },
                       ],
                       model1: sessionStorage.getItem('type')
    }
  },
   methods:{
    change(value){
  console.log(value)
                sessionStorage.setItem('type' ,value)
                this.reload();
          },
     getMennu() {
         var baseUrl = this.api.baseUrl;
          console.log('获取菜单')
         					   // var params = new URLSearchParams();
         					   // params.append('userName', this.name);
         					   // params.append('passWord', this.pas);
  // var params =     {
  //          					                      MenuID:''

  //          					                    }
                  	 this.$ajax.get(baseUrl+'api/admin/MenuSetting/GetTreeList',{
                                params: {
                                 StaffID:0
                                }}).then(res => {
                      	console.log(res)
                         if(res.data.code == 200 &&res.data.succcess ){
         						    this.$Message.success('获取成功');
         						    // sessionStorage.setItem('MJLoginname' ,this.name)
         						   this.menuList= res.data.data
                       console.log(this.menuList)
         						}else{
         							  this.$Message.error(res.data.msg);
         						}
                      }).catch(err => {             //
                        console.log(err)
                      });


              },
capital(e){
  console.log(e)
},
quit(){
  console.log('333333')
}
   }

    }
</script>



// WEBPACK FOOTER //
// src/components/home.vue